<template>
    <invoices-index>
        <template v-slot:title>
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Commission Invoices</h1>
        </template>
        <template v-slot:searchfilter>
            <invoice-search-filter
                :show-filter="false"
                v-model:value="form.search"
                class="hidden lg:flex w-full max-w-xl py-3 ml-auto"
                @reset="reset">
            </invoice-search-filter>
        </template>

        <invoice-search-filter
            :show-filter="false"
            v-model:value="form.search"
            class="lg:hidden w-full max-w-xl py-3 ml-auto"
            @reset="reset">
        </invoice-search-filter>

        <div class="flex flex-col gap-3 py-3 lg:flex-row lg:items-end">
            <invoice-filters
                class="w-full max-w-full lg:flex-1"
                v-model:date_from="form.filters.date_from"
                v-model:date_to="form.filters.date_to"
                v-model:status="form.filters.status"
                v-model:office="form.filters.office"
                v-model:client="form.filters.client"
                :clients="clients"
                :offices="offices">
            </invoice-filters>

            <a
                :href="exportUrl"
                class="inline-flex items-center justify-center rounded-md bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800 lg:mb-[2px]"
            >
                Export
            </a>
        </div>

        <div class="w-full space-y-3">
            <Head title="Invoices"/>
            <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
                <div class="flex flex-col mt-3 space-y-3">
                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead class="bg-gray-50">
                                        <tr>
                                            <th scope="col"
                                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                Invoice Reference
                                            </th>
                                            <th scope="col"
                                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                Project Reference
                                            </th>
                                            <th scope="col"
                                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                Invoice Date
                                            </th>
                                            <th scope="col"
                                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                Amount Invoiced
                                            </th>
                                            <th scope="col"
                                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                Due Date
                                            </th>
                                            <th scope="col"
                                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                Date Paid
                                            </th>
                                            <th scope="col"
                                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                Amount Paid
                                            </th>
                                            <th scope="col"
                                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                Office
                                            </th>
                                            <th scope="col"
                                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                Status
                                            </th>
                                            <th scope="col"
                                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">

                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="invoices.data.length > 0"
                                            v-for="(invoice,index) in invoices.data"
                                            :key="index"
                                        >
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {{ invoice.reference }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {{ invoice.project.reference }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {{ moment(invoice.invoiced_at, 'YYYY-MM-DD').format('DD-MM-YYYY') }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                <span v-if="invoice.currency_code">
                                                    {{ formatCurrency(invoice.amount, invoice?.currency_code, true) }}
                                                </span>
                                                <span v-else>
                                                    {{ invoice.amount }}
                                                </span>
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {{ moment(invoice.due_at, 'YYYY-MM-DD').format('DD-MM-YYYY') }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                <span v-if="invoice.date_paid">{{ moment(invoice.date_paid, 'YYYY-MM-DD').format('DD-MM-YYYY') }}</span>
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                <span v-if="invoice.currency_code">
                                                    {{ formatCurrency(invoice.amount_paid, invoice?.currency_code, true) }}
                                                </span>
                                                <span v-else>
                                                    {{ invoice.amount_paid }}
                                                </span>
                                            </td>
                                            <td
                                                v-show="invoice.office"
                                                class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {{ invoice.office?.name }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {{ invoice.status }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                <a
                                                    class="flex gap-1 items-center cursor-pointer"
                                                    :href="downloadInvoice(invoice)"
                                                    title="Download Invoice"
                                                >
                                                    <DocumentDownloadIcon class="w-4 h-4" /> <span class="text-sm">Download</span>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr v-else>
                                            <td colspan="7" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                There are no invoices available.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <Pagination :links="invoices.links"/>
                </div>
            </div>
        </div>
    </invoices-index>
</template>

<script>
import InvoicesIndex from "@/Pages/Frontend/Invoices/Index"
import InvoiceSearchFilter from "@/Components/InvoiceSearchFilter.vue";
import InvoiceFilters from "@/Components/InvoiceFilters.vue"
import Authenticated from "@/Layouts/Authenticated.vue";
import { useForm, Link, Head } from "@inertiajs/vue3";
import Pagination from "@/Components/Pagination.vue";
import moment from "moment/moment";
import mapValues from 'lodash/mapValues';
import debounce from "lodash/debounce";
import pickBy from "lodash/pickBy";
import { DocumentDownloadIcon } from "@heroicons/vue/outline";

export default {
    layout: Authenticated,
    components: {
        Head,
        Link,
        Pagination,
        InvoiceSearchFilter,
        InvoiceFilters,
        InvoicesIndex,
        DocumentDownloadIcon
    },
    props: {
        invoices: Object,
        offices: Array,
        clients: Array,
        search: String,
        filters: Object,
    },
    data() {
        return {
            form: useForm({
                search: this.search ?? null,
                filters: {
                    date_from: this.filters?.date_from ?? null,
                    date_to: this.filters?.date_to ?? null,
                    status: this.filters?.status ?? null,
                    office: this.filters?.office ?? null,
                    client: this.filters?.client ?? null,
                }
            })
        }
    },
    created() {
      this.moment = moment;
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        downloadInvoice(invoice) {
            return route('frontend.project.commission.download', [invoice?.project.id, invoice.id])
        },
        requestParams() {
            const filters = pickBy(this.form.filters);

            return pickBy({
                search: this.form.search,
                filters: Object.keys(filters).length ? filters : null,
            });
        },
    },
    computed: {
        exportUrl() {
            return route('frontend.invoices.commission-invoices.export', this.requestParams());
        },
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function () {
                this.$inertia.get(route('frontend.invoices.commission-invoices'), this.requestParams(), {preserveState: true})
            }, 500),
        },
    }
}
</script>
